import script from "./customer.vue?vue&type=script&setup=true&lang=ts"
export * from "./customer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__